var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThermometerFilled = function SvgThermometerFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.2262V16.6021L11.2476 16.885C11.7159 17.4198 12 18.1214 12 18.8934C12 20.5757 10.6493 21.9257 9 21.9257C7.35072 21.9257 6 20.5757 6 18.8934C6 18.1214 6.28413 17.4198 6.75237 16.885L7 16.6021V16.2262V5.78842C7 4.66287 7.903 3.76419 9 3.76419C10.097 3.76419 11 4.66287 11 5.78842V16.2262ZM10.5 5.78842C10.5 4.96536 9.836 4.28438 9 4.28438C8.164 4.28438 7.5 4.96537 7.5 5.78842V17.5654C7.18877 17.9195 7 18.3849 7 18.8934C7 19.9949 7.88786 20.9015 9 20.9015C10.1121 20.9015 11 19.9949 11 18.8934C11 18.3849 10.8112 17.9195 10.5 17.5654V5.78842ZM18 7.80458C18 8.93013 17.097 9.82881 16 9.82881C14.903 9.82881 14 8.93013 14 7.80458C14 6.67903 14.903 5.78035 16 5.78035C17.097 5.78035 18 6.67903 18 7.80458Z",
    stroke: "#E76F00",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThermometerFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thermometer-filled.46c8eed4.svg";
export { ForwardRef as ReactComponent };